function init() {
  const scrollToTarget = function (selector, offset = 0) {
    const target = document.querySelector(selector);
    if (!target) return;

    let top = target.getBoundingClientRect().top + window.pageYOffset;

    const wpAdminBar = document.getElementById('wpadminbar');
    if (wpAdminBar) {
      offset += wpAdminBar.offsetHeight;
    }

    // const banner = document.querySelector('.banner');
    // if (banner) {
    //   offset += banner.offsetHeight;
    // }

    offset += 40;

    window.scrollTo({
      top: top - offset,
      behavior: 'smooth',
    });
  };

  const links = [];

  links.push({ href: '#ingredients', target: '[data-id="ingredients"]' });
  links.push({ href: '#segments', target: '[data-id="segments"]' });

  $('a.scroll-to').on('click', function (e) {
    if($(this).attr('href').includes('#segments') && $('[data-id="segments"]').length) {
      e.preventDefault();
      scrollToTarget('[data-id="segments"]');
    }
    else if($(this).attr('href').includes('#ingredients') && $('[data-id="ingredients"]').length) {
      e.preventDefault();
      scrollToTarget('[data-id="ingredients"]');
    }
  });

  if (window.location.hash) {
    const currentHash = window.location.hash;
    const link = links.find((link) => link.href === currentHash);

    if (link) {
      setTimeout(() => {
        scrollToTarget(link.target);
      }, 500); // Delay for page load
    }
  }
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/anchors.js